export default function getDecimalPlaces(value: string | number | null | undefined): number {
  if (value === null || value === undefined) return 0; // Handle null/undefined
  const strValue = value.toString();

  return strValue.includes('.') ? strValue.split('.')[1].length : 0;
}
